<template>
    <div class="pa-t-20  bg-round bg-fff">
        <div class="container">
            <Bread class="ma-t-10"/>
        </div>

        <div class="container line-height-35 main-md vhtml">
            <div v-html="detail.Content"></div>
        </div>

        
    </div>
</template>
<style lang="scss" scoped>
</style>
<script>
    import {getOther} from "../../api.js";
    export default {
        name: "merge",
        data() {
            return {
                detail:"",
            };
        },
        created() {
            console.log("开始开发")
            this.getDetail();
        },
        
        methods: {
            //获取数据
            getDetail() {
                let data = {
                    code: "league",
                };
                getOther(data).then((res) => {
                    console.log(res);
                    this.detail = res.data.Data;
                });
            },
        },
    };
</script>
